import * as React from "react";
import type { SVGProps } from "react";
const SvgDateCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      fillOpacity={0.2}
      d="M16 18H2V7h14zM13 0v2H5V0H3v2H2C.89 2 0 2.89 0 4v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1V0"
    />
  </svg>
);
export default SvgDateCalendar;
